import { dateFormat } from 'helpers/StringNumberFunction/FormatDate'
import { amtStr } from 'helpers/StringNumberFunction/NumFormatters'
import QRCode from 'react-qr-code'
import React from 'react'

export const ELetterServiceAP = ({
  docType,
  previewDetail,
  allpreviewDetail,
  paramVal,
  ItemIndex,
}) => {
  let APInvoice

  const creditorDetails = {
    '[CreditorName]':
      previewDetail?.CreditorAccount?.CompanyName! ??
      previewDetail?.CreditorAccount?.DebtorName!,
    '[CreditorAddress]': `${
      previewDetail?.CreditorAccount?.Address?.address
    }<br />
          ${
            previewDetail?.CreditorAccount?.Address?.country == 'Singapore'
              ? `${previewDetail?.CreditorAccount?.Address?.country} ${previewDetail?.CreditorAccount?.Address?.postCode}`
              : `${previewDetail?.CreditorAccount?.Address?.postCode} ${previewDetail?.CreditorAccount?.Address?.city}, 
            ${previewDetail?.CreditorAccount?.Address?.state}, ${previewDetail?.CreditorAccount?.Address?.country}`
          }
           <br />`,
    '[CreditorContactName]':
      previewDetail?.CreditorAccount?.CreditorContact[0]?.Name! ?? '',
    '[CreditorContactNo]':
      previewDetail?.CreditorAccount?.CreditorContact[0]?.ContactNo! ?? '',
    '[CreditorContactEmail]':
      previewDetail?.CreditorAccount?.CreditorContact[0]?.Email! ?? '',
    '[CreditorCompanyRegNo]':
      previewDetail?.CreditorAccount?.CompanyRegNo! ?? '',
    '[CreditorBankAccName]': previewDetail?.CreditorAccount?.BankName! ?? '',
    '[CreditorBankAccNo]': previewDetail?.CreditorAccount?.BankAccountNo! ?? '',
    '[CreditorTIN]': previewDetail?.CreditorAccount?.einvoice_TIN! ?? '',
    '[CreditorSSTRegNo]': previewDetail?.SSTRegNo! ?? '',
    '[CreditorGSTRegNo]': previewDetail?.GSTRegNo! ?? '',
    '[QRCode]':
      previewDetail?.is_einvoice && previewDetail?.einvoice_qr_url ? (
        <QRCode
          size={128}
          style={{
            height: 'auto',
            maxWidth: '100%',
            width: '100%',
          }}
          value={previewDetail?.einvoice_qr_url}
          viewBox={`0 0 128 128`}
        />
      ) : (
        ''
      ),
  }

  // function to convert number to words
  function numberToWords(amount: number): string {
    const a = [
      '',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
      'Eleven',
      'Twelve',
      'Thirteen',
      'Fourteen',
      'Fifteen',
      'Sixteen',
      'Seventeen',
      'Eighteen',
      'Nineteen',
    ]
    const b = [
      '',
      '',
      'Twenty',
      'Thirty',
      'Forty',
      'Fifty',
      'Sixty',
      'Seventy',
      'Eighty',
      'Ninety',
    ]

    const toWords = (num: number): string => {
      if (num === 0) return 'Zero'
      if (num < 20) return a[num]
      if (num < 100)
        return b[Math.floor(num / 10)] + (num % 10 ? ' ' + a[num % 10] : '')
      if (num < 1000)
        return (
          a[Math.floor(num / 100)] +
          ' Hundred' +
          (num % 100 ? ' ' + toWords(num % 100) : '')
        )
      if (num < 1000000)
        return (
          toWords(Math.floor(num / 1000)) +
          ' Thousand' +
          (num % 1000 ? ' ' + toWords(num % 1000) : '')
        )
      return (
        toWords(Math.floor(num / 1000000)) +
        ' Million' +
        (num % 1000000 ? ' ' + toWords(num % 1000000) : '')
      )
    }

    const fixed = Number(amount).toFixed(2)
    const [ringgitStr, senStr] = fixed.split('.')
    const ringgit = parseInt(ringgitStr, 10)
    const sen = parseInt(senStr, 10)

    let result = ''

    if (ringgit > 0) {
      result += toWords(ringgit) + ' Ringgit'
    }

    if (sen > 0) {
      result += (ringgit > 0 ? ' and ' : '') + toWords(sen) + ' Sen'
    }

    if (!result) result = ' Zero Ringgit'

    return result + ' Only'
  }

  switch (docType) {
    case 'payment':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '', //to be changed
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        // Item Info
        items: previewDetail?.AllocationWithCN?.sort((a, b) => {
          const dateA = new Date(a.DocDate ?? '').getTime()
          const dateB = new Date(b.DocDate ?? '').getTime()
          return dateB - dateA
        })?.map((el, i) => {
          return {
            '[Index]': ItemIndex ?? 0 + i + 1,
            '[AllocationDocDate]': el?.DocDate ? dateFormat(el?.DocDate!) : '',
            '[AllocationDocNo]': el?.DocNo! ?? '',
            '[AllocationRefNo]': el?.RefNo! ?? '',
            '[AllocationDescription]': el?.Description!,
            '[AllocationAmt]':
              el?.CreditOrDebit === 'Debit'
                ? `(${amtStr(el?.AllocatedAmt!)})`
                : amtStr(el?.AllocatedAmt!),
            '[AllocDefaultAmt]': amtStr(el?.CreditDefaultAmt!),
            subItem: el?.AllocatedDocs?.map((v, index) => {
              return {
                '[SubItemIndex]': index + 1,
                '[AllocatedDetail]':
                  v?.DebitDocNo! +
                  ' ' +
                  dateFormat(v?.DebitDocDate!) +
                  ' ' +
                  '-' +
                  ' ' +
                  v?.DebitDescription!,
                '[AllocatedDocAmt]': !!v?.AllocationAmt
                  ? '(' + amtStr(v?.AllocationAmt!) + ')'
                  : 0,
              }
            }),
          }
        }),
        '[SumAllocationAmt]': amtStr(allpreviewDetail?.DocAmt),
        '[SumAllocationAmtWord]': numberToWords(allpreviewDetail?.DocAmt),
      })

    case 'advance':
      return Object.assign(paramVal, creditorDetails, {
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        '[TotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[SumTotalAmt]': amtStr(previewDetail?.DocAmt!),
        '[SumAmtWords]': numberToWords(previewDetail?.DocAmt!),
        '[PaymentMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
      })

    case 'refund':
      return Object.assign(paramVal, creditorDetails, {
        // Left Header info
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        '[RefundMethod]': previewDetail?.PaymentMethod?.Name! ?? '',
        '[ChequeNo]': previewDetail?.ChequeNo! ?? '',
        '[CompanyBankAccCode]': previewDetail?.BankAccount?.Code! ?? '',
        '[CompanyBankAccNo]': previewDetail?.BankAccount?.AccountNo! ?? '',
        // Item Listing
        items: previewDetail?.Allocation?.map((el, i) => {
          return {
            '[AllocationDocDate]': dateFormat(
              el?.DebitDocDate! ?? el?.CreditDocDate!
            ),
            '[AllocationDocNo]': el?.DebitDocNo! ?? el?.CreditDocNo! ?? '',
            '[AllocationRefNo]': el?.DebitRefNo! ?? el?.CreditRefNo! ?? '',
            '[AllocationRemark]': el?.Description! ?? '',
            '[AllocationAmt]': amtStr(el?.AllocationAmt!),
          }
        }),
        //Total Amount Footer
        '[SumAllocationAmt]': allpreviewDetail?.Allocation?.reduce(
          (a, b) => a + Number(b?.AllocationAmt),
          0
        ).toFixed(2),
        '[SumAllocationAmtWords]': numberToWords(
          allpreviewDetail?.Allocation?.reduce(
            (a, b) => a + Number(b?.AllocationAmt),
            0
          )
        ),
      })

    case 'invoice':
      return Object.assign(paramVal, APInvoice)

    case 'credit-note':
      return Object.assign(paramVal, creditorDetails, {
        // Left Header info
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        // Item Listing
        items: previewDetail?.APCreditNoteItem?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemRemark]': el?.Remark!,
            '[TaxRate]': el?.TaxRate! + '%',
            '[BaseAmt]': amtStr(el?.Amount!),
            '[TaxAmt]': amtStr(el?.TaxAmt!),
            '[TotalAmt]': amtStr(el?.DocAmt!),
          }
        }),
        // Item Listing
        allocItems: previewDetail?.Allocation?.map((el, i) => {
          return {
            '[AllocIndex]': i + 1,
            '[AllocDocDate]': !!el?.CreditDocDate
              ? dateFormat(el?.CreditDocDate!)
              : '',
            '[AllocDocNo]': !!el?.CreditDocNo ? el?.CreditDocNo! : '',
            '[AllocDesc]': !!el?.Description ? el?.Description! : '',
            '[AllocAmt]': !!el?.AllocationAmt ? amtStr(el?.AllocationAmt!) : '',
          }
        }),
        // Total Amount Footer
        '[SumBaseAmt]': allpreviewDetail?.APCreditNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0
          ).toFixed(2)
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APCreditNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0
          ).toFixed(2)
        ),
      })

    case 'debit-note':
      return Object.assign(paramVal, creditorDetails, {
        // Left Header info
        '[Description]': previewDetail?.Description! ?? '',
        '[DocRemark]': previewDetail?.Remark! ?? '',
        '[Remark]': previewDetail?.Remark! ?? '',
        // Right Header Info
        '[DocumentNo]': previewDetail?.DocNo!,
        '[DocumentDate]': dateFormat(previewDetail?.DocDate!),
        '[ReferenceNo]': previewDetail?.RefNo! ?? '',
        // Item Listing
        items: previewDetail?.APDebitNoteItem?.map((el, i) => {
          return {
            '[Index]': ItemIndex + i + 1,
            '[ItemRemark]': el?.Remark!,
            '[TaxRate]': el?.TaxRate! + '%',
            '[BaseAmt]': amtStr(el?.Amount!),
            '[TaxAmt]': amtStr(el?.TaxAmt!),
            '[TotalAmt]': amtStr(el?.DocAmt!),
          }
        }),
        // Total Amount Footer
        '[SumBaseAmt]': allpreviewDetail?.APDebitNoteItem?.reduce(
          (a, b) => a + Number(b?.Amount),
          0
        ).toFixed(2),
        '[SumTaxAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.TaxAmt),
            0
          ).toFixed(2)
        ),
        '[SumTotalAmt]': amtStr(
          allpreviewDetail?.APDebitNoteItem?.reduce(
            (a, b) => a + Number(b?.DocAmt),
            0
          ).toFixed(2)
        ),
      })
  }
}
